import { useTranslation } from "react-i18next"
import * as yup from "yup"
import { translationKeys } from "../../../util/translationKeys"

export const useForgotPasswordSchemaProperties = () => {
  const { t } = useTranslation()
  const forgotPasswordSchemaProperties = yup.object().shape({
    email: yup
      .string()
      .email(`${t(translationKeys.inputEmailErrorMessage)}`)
      .required(`${t(translationKeys.inputEmailNoInput)}`),
  })
  return forgotPasswordSchemaProperties
}
